export function initAnimations() {
  let options = {
    root: null,
    rootMargin: "0px",
    threshold: 0.5,
  };

  const $imagesAbout = document.getElementById("about-images");
  const $contentAbout = document.getElementById("about-content");
  const $pricesWrapper = document.getElementById("prices-wrapper");
  const $onlineBooking = document.getElementById("online-booking");
  const $contact = document.getElementById("contact");

  const $featuresCards = document.querySelectorAll(".features__card-item");
  const $barbersCards = document.querySelectorAll(".barbers__item-cards");
  const $showcaseItem = document.querySelectorAll(".showcase__item");


  const arrElements = [$imagesAbout, $contentAbout, $pricesWrapper, $onlineBooking, $contact];

  let callback = function (
    entries: IntersectionObserverEntry[],
    observer: IntersectionObserver
  ) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const attrValue = entry.target.getAttribute("data-anim");
        if (attrValue === null) return;
        entry.target.classList.add(attrValue);

        observer.unobserve(entry.target);
      }
    });
  };

  let observer = new IntersectionObserver(callback, options);

  arrElements.forEach((elem) => {
    if (!elem) return;

    observer.observe(elem);
  });

  if ($featuresCards.length > 0) {
    $featuresCards.forEach((elem) => observer.observe(elem));
  }

  if ($barbersCards.length > 0) {
    $barbersCards.forEach((elem) => observer.observe(elem));
  }

  if ($showcaseItem.length > 0) {
    $showcaseItem.forEach((elem) => observer.observe(elem));
  }
}
